import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import _ from 'underscore';

import type {SavedFilter} from 'nutshell-core/types';

import {FilterSavePopover} from '../../filtering/filter-save-popover';
import {FilterSharePopover} from '../../filtering/filter-share-popover';

import {TitleBarSaveControls} from './title-bar-save-controls';
import type {SavedFilterHumanReadableType} from './title-bar-save-controls';

type Props = {
    hasSaveControls?: boolean;
    savedFilterHumanReadableType: SavedFilterHumanReadableType;
    onSavedFiltersButtonClick: () => any;
    activeSavedFilter: SavedFilter<any> | null | undefined;
    usersAndTeams: Array<any>;
    canResave: boolean;
    isResaving: boolean;
    isSavingNew: boolean;
    isSavingSharePreferences: boolean;
    errorText: string | null | undefined;
    onDismissPopoverError: () => any;
    onUpdateSharePreferences: (
        id: string,
        params: {
            isShared: boolean;
            links: any;
        }
    ) => Promise<any>;
    onResaveFilter: (id: string) => any;
    onSaveNewFilter: (arg1: string) => Promise<any>;
    parentType: ParentType;
};

type State = {
    isSharePopoverOpen: boolean;
    isSavePopoverOpen: boolean;
};

export type ParentType = 'entity-list' | 'reports';

export class TitleBarSaveControlsContainer extends React.PureComponent<Props, State> {
    saveAnchor: HTMLElement | null | undefined;
    saveAsAnchor: HTMLElement | null | undefined;
    shareAnchor: HTMLElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isSharePopoverOpen: false,
            isSavePopoverOpen: false,
        };
    }

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    render() {
        return (
            <React.Fragment>
                <TitleBarSaveControls
                    activeSavedFilter={this.props.activeSavedFilter}
                    hasSaveControls={this.props.hasSaveControls}
                    savedFilterHumanReadableType={this.props.savedFilterHumanReadableType}
                    usersAndTeams={this.props.usersAndTeams}
                    canResave={this.props.canResave}
                    isResaving={this.props.isResaving}
                    onSavedFiltersButtonClick={this.props.onSavedFiltersButtonClick}
                    onOpenSharePopover={this.handleOpenSharePopover}
                    onOpenSavePopover={this.handleOpenSavePopover}
                    onResaveFilter={this.props.onResaveFilter}
                    getSaveAnchor={(node) => {
                        this.saveAnchor = node;
                    }}
                    getSaveAsAnchor={(node) => {
                        this.saveAsAnchor = node;
                    }}
                    getShareAnchor={(node) => {
                        this.shareAnchor = node;
                    }}
                    parentType={this.props.parentType}
                />
                {this.state.isSavePopoverOpen ? this.renderFilterSavePopover() : undefined}
                {this.state.isSharePopoverOpen &&
                this.props.activeSavedFilter &&
                this.shareAnchor &&
                !NutClientConfig.hasSharedListsFF ? (
                    <FilterSharePopover
                        errorText={this.props.errorText}
                        onDismissError={this.props.onDismissPopoverError}
                        savedFilter={this.props.activeSavedFilter}
                        anchor={this.shareAnchor}
                        title={`Share ${this.props.savedFilterHumanReadableType} with…`}
                        // @ts-expect-error
                        onBlur={this.handleCloseSharePopover}
                        onClose={this.handleCloseSharePopover}
                        isSaving={this.props.isSavingSharePreferences}
                        onSave={this.handleSaveSharePreferences}
                        location='bottom'
                    />
                ) : undefined}
            </React.Fragment>
        );
    }

    renderFilterSavePopover = () => {
        return (
            <FilterSavePopover
                errorText={this.props.errorText}
                title={
                    this.props.activeSavedFilter
                        ? `Save ${this.props.savedFilterHumanReadableType} as`
                        : `Save ${this.props.savedFilterHumanReadableType}`
                }
                placeholderText={`Name this ${this.props.savedFilterHumanReadableType}…`}
                anchor={this.props.activeSavedFilter ? this.saveAsAnchor : this.saveAnchor}
                location='bottom-left'
                isSaving={this.props.isSavingNew}
                onDismissError={this.props.onDismissPopoverError}
                onSave={this.handleSaveNewReport}
                onClose={this.handleCloseSavePopover}
            />
        );
    };

    handleSaveSharePreferences = (isShared: boolean, usersAndTeams: Array<any>) => {
        const activeSavedFilter = this.props.activeSavedFilter;
        if (activeSavedFilter) {
            this.props
                .onUpdateSharePreferences(activeSavedFilter.id, {
                    isShared: isShared,
                    links: {
                        ...activeSavedFilter.links,
                        usersAndTeams: _.pluck(usersAndTeams, 'id'),
                    },
                })
                .then(() => {
                    this.setState({isSharePopoverOpen: false});
                });
        }
    };

    handleSaveNewReport = (name: string) => {
        this.props.onSaveNewFilter(name).then(() => {
            this.setState({isSavePopoverOpen: false});
        });
    };

    handleOpenSharePopover = () => {
        this.setState({isSharePopoverOpen: true});
    };

    handleCloseSharePopover = () => {
        this.setState({isSharePopoverOpen: false});
    };

    handleOpenSavePopover = () => {
        this.setState({isSavePopoverOpen: true});
    };

    handleCloseSavePopover = () => {
        this.setState({isSavePopoverOpen: false});
    };
}
